import { render, staticRenderFns } from "./ViewPort.vue?vue&type=template&id=162d7ce8&scoped=true&"
import script from "./ViewPort.vue?vue&type=script&lang=js&"
export * from "./ViewPort.vue?vue&type=script&lang=js&"
import style0 from "./ViewPort.vue?vue&type=style&index=0&id=162d7ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162d7ce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('162d7ce8', component.options)
    } else {
      api.reload('162d7ce8', component.options)
    }
    module.hot.accept("./ViewPort.vue?vue&type=template&id=162d7ce8&scoped=true&", function () {
      api.rerender('162d7ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/ScreenEditor/ViewPort.vue"
export default component.exports